export default { sha: '60b4a4a25fd8c95d7b49222729edc2ef2ac1850b', buildNumber: 'undefined' }
